'use client';

import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormDialog } from '../FormDialog/FormDialog';
export const TextInputDialog = ({
  open,
  onClose,
  onSave,
  title,
  description,
  label = 'Comments',
  placeholder,
  initialValue = '',
  confirmButtonText = 'Save',
  cancelButtonText = 'Cancel',
  minRows = 5,
  required = true,
  maxWidth = 'sm'
}) => {
  const [value, setValue] = useState(initialValue);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (open) setValue(initialValue ?? '');
  }, [open, initialValue]);
  const trimmed = value.trim();
  const disableConfirm = required && !trimmed;
  const handleSave = async () => {
    if (disableConfirm || saving) return;
    setSaving(true);
    try {
      await onSave(trimmed);
      onClose();
    } finally {
      setSaving(false);
    }
  };
  return <FormDialog open={open} onClose={onClose} onConfirm={handleSave} title={title} description={description} confirmButtonText={confirmButtonText} cancelButtonText={cancelButtonText} disableConfirm={disableConfirm} confirmLoading={saving} maxWidth={maxWidth}>
            <div className="pt-2">
                <TextField autoFocus fullWidth multiline minRows={minRows} label={label} placeholder={placeholder} value={value} onChange={e => setValue(e.target.value)} variant="outlined" />
            </div>
        </FormDialog>;
};
export default TextInputDialog;